// Renders a react-querybuilder group ({combinator, not, rules: [...]}) as readable text,
// e.g. "unit number > 1000 AND car type = X". Rules may nest further groups.
export const formatEnvQueryGroup = group => {
  if (!group || !Array.isArray(group.rules) || !group.rules.length) return '';
  const parts = group.rules.map(rule =>
    rule.rules ? `(${formatEnvQueryGroup(rule)})` : `${rule.field} ${rule.operator} ${rule.value}`
  );
  const joined = parts.join(` ${(group.combinator || 'and').toUpperCase()} `);
  return group.not ? `NOT (${joined})` : joined;
};
